import { Component, OnInit } from '@angular/core'
import { FormControl, FormGroup } from '@angular/forms'
import {
  clearAdvancedSettings,
  defaultAdvancedSettings,
  RootState,
  selectCashBreakAdvancedSettings,
  setAdvancedSettings,
} from '@helios/state-management'
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap'
import { Store } from '@ngrx/store'

@Component({
  selector: 'hs-cash-break-advanced-settings-modal',
  templateUrl: './cash-break-advanced-settings-modal.component.html',
  styleUrls: ['./cash-break-advanced-settings-modal.component.scss'],
})
export class CashBreakAdvancedSettingsModalComponent implements OnInit {
  preserveNonDefaultSettingsToggle = new FormControl(false)
  unmatchedExtTransactionsToggle = new FormControl(false)
  ignoredExtTransactionsToggle = new FormControl(false)
  unmatchedUnclearedCwTxToggle = new FormControl(false)
  clearedCashTransactionsToggle = new FormControl(false)
  clearedMmfTradesToggle = new FormControl(false)

  advancedSettingsForm = new FormGroup({
    preserveNonDefaultSettings: this.preserveNonDefaultSettingsToggle,
    unmatchedExtTransactions: this.unmatchedExtTransactionsToggle,
    ignoredExtTransactions: this.ignoredExtTransactionsToggle,
    unmatchedUnclearedCwTx: this.unmatchedUnclearedCwTxToggle,
    clearedCashTransactions: this.clearedCashTransactionsToggle,
    clearedMmfTrades: this.clearedMmfTradesToggle,
  })
  constructor(
    public activeModal: NgbActiveModal,
    private readonly store: Store<RootState>,
  ) {}

  ngOnInit(): void {
    this.store.select(selectCashBreakAdvancedSettings).subscribe(state => {
      this.advancedSettingsForm.setValue(state)
    })
  }

  resetToDefault() {
    this.advancedSettingsForm.setValue(defaultAdvancedSettings)
    this.store.dispatch(clearAdvancedSettings())
  }

  runSolver() {
    if (this.preserveNonDefaultSettingsToggle.value) {
      this.store.dispatch(setAdvancedSettings(this.advancedSettingsForm.value))
    } else {
      this.store.dispatch(clearAdvancedSettings())
    }
    this.activeModal.close(this.advancedSettingsForm.value)
  }
}
